<button
    mat-icon-button
    [matMenuTriggerFor]="filterMenu"
    (menuOpened)="onMenuOpened()">
    <mat-icon>filter_list</mat-icon>
</button>
<mat-menu #filterMenu="matMenu" class="table-filter-menu">
    <div class="p-2 table-filter-menu">
        <div *ngIf="filterType === 'text'" class="input-search">
                <input matInput
                       [(ngModel)]="textValue"
                       (ngModelChange)="onTextInput($event)"
                       placeholder="{{ 'common.search' | translate }}"
                       (click)="$event.stopPropagation()"
                       (keydown.enter)="onTextSearch()"
                       autocomplete="off"
                       >
                <button mat-icon-button matSuffix (click)="onTextSearch()">
                    <mat-icon class="search-icon">search</mat-icon>
                </button>
                <button mat-icon-button matSuffix *ngIf="textValue" (click)="onTextClear()">
                    <mat-icon>close</mat-icon>
                </button>
        </div>
        <ng-container *ngIf="filterType === 'select'">
        <nekta-search *ngIf="withVirtualScroll && (multiple || searchFn)"
                      size="full"
                      [searchString]="searchString"
                      (searchStringChange)="onSearch($event)"
                      (click)="$event.stopPropagation()"
        ></nekta-search>
        <mat-selection-list
            *ngIf="!multiple"
            #matSelectionList
            color="primary"
            dense
            disableRipple
            [multiple]="false"
            (selectionChange)="onFilterChange($event.options[0].value)"
        >
            <ng-container *ngIf="withVirtualScroll; else baseListSingle;">
                <cdk-virtual-scroll-viewport itemSize="10" class="virtual-scroll">
                    <mat-list-option
                        class="all-option"
                        [class.mat-selection-list-selected-custom]="selectedOption === null"
                        [value]="null">
                        {{ 'common.all' | translate }}
                    </mat-list-option>
                    <mat-list-option
                        *cdkVirtualFor="let option of filteredOptions; trackBy: trackByFn;"
                        [class.mat-selection-list-selected-custom]="selectedOption === option.id"
                        [value]="option.id"
                    >
                        <p [class.option]="selectedOption !== option.id">
                            {{ option.title }}
                        </p>
                    </mat-list-option>
                </cdk-virtual-scroll-viewport>
            </ng-container>
            <ng-template #baseListSingle>
                <mat-list-option
                    [class.mat-selection-list-selected-custom]="selectedOption === null"
                    [value]="null">
                    {{ 'common.all' | translate }}
                </mat-list-option>
                <mat-list-option
                    *ngFor="let option of filteredOptions; trackBy: trackByFn;"
                    [class.mat-selection-list-selected-custom]="selectedOption === option.id"
                    [value]="option.id"
                >
                    <p [class.option]="selectedOption !== option.id">
                        {{ option.title }}
                    </p>
                </mat-list-option>
            </ng-template>
        </mat-selection-list>
        <mat-selection-list
            *ngIf="multiple"
            #matSelectionList
            color="primary"
            dense
            disableRipple
            [multiple]="true"
            [(ngModel)]="selectedValues"
            (selectionChange)="onMultiSelectionChange()"
        >
            <ng-container *ngIf="withVirtualScroll; else baseListMulti">
                <cdk-virtual-scroll-viewport itemSize="10" class="virtual-scroll">
                    <mat-list-option class="all-option"
                                     [value]="null"
                                     [class.mat-selection-list-selected-custom]="selectedValues.length === 0"
                    >
                        {{ 'common.all' | translate }}
                    </mat-list-option>
                    <mat-list-option
                        *cdkVirtualFor="let option of filteredOptions; trackBy: trackByFn;"
                        [value]="option.id"
                        [class.mat-selection-list-selected-custom]="selectedValues.includes(option.id)"
                    >
                        {{ option.title }}
                    </mat-list-option>
                </cdk-virtual-scroll-viewport>
            </ng-container>
            <ng-template #baseListMulti>
                <mat-list-option [value]="null">
                    {{ 'common.all' | translate }}
                </mat-list-option>
                <mat-list-option
                    *ngFor="let option of filteredOptions; trackBy: trackByFn;"
                    [value]="option.id"
                >
                    {{ option.title }}
                </mat-list-option>
            </ng-template>
        </mat-selection-list>
        <!-- серверный список пуст: либо он ещё едет, либо по строке ничего не нашлось -->
        <p *ngIf="searchFn && !filteredOptions.length" class="server-empty">
            {{ (isLoading ? 'common.loading' : 'devices.add.device.input.notFound') | translate }}
        </p>
        </ng-container>
    </div>
</mat-menu>
